<template>
  <div class="mt-4 md:mt-5 pb-12">
    <div class="h1 font-secondary felx mt-4 mb-4 md:mb-4">
      {{ $t('destinationTabArea') }}
    </div>
    <p
      v-show="subtext"
      class="felx mt-4 mb-4 md:mb-4"
      v-html="subtext"
    />
    <DestinationFlexCardHolder
      class="mt-4 md:mt-5"
      :section="getFilteredSection('areas_of_interest')"
      @card-click="handleCardClick"
    />
    <DestinationMapWithPopups
      v-if="getFilteredSection('areas_of_interest')"
      ref="mapWithPopups"
      :destination="destination"
      :filled-section="getFilteredSection('areas_of_interest')"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  destination: {
    type: Object,
    default: () => ({}),
  },
  filledSections: {
    type: Array,
    default: () => [],
  },
})
const mapWithPopups = ref(null)

const handleCardClick = (item) => {
  mapWithPopups.value.highlightedOpen(item)
}

const subtext = computed(() => {
  return getFilteredSection('areas_of_interest').ingress
})

const getFilteredSection = (filterString) => {
  const section = props.filledSections.find(section => section.type === filterString)
  return section ? section.data : null
}
</script>
